module.exports = __webpack_public_path__ + "img/product_bg_01.706393c.png";